<template>
  <div>
    <strong>Currently funded projects</strong>
    <div class="columns  is-multiline">
      <resource-list-item v-for="resource in resources.filter(x => !x.finished)" :key="resource.id"
        :resource="resource"></resource-list-item>
    </div>
    <hr />
    <strong>Previous projects</strong>
    <div class="columns  is-multiline">
      <resource-list-item v-for="resource in resources.filter(x => x.finished)" :key="resource.id"
        :resource="resource"></resource-list-item>
    </div>
  </div>
</template>

<script>
import ResourceListItem from '@/components/ResourceListItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Projects',
  components: {
    ResourceListItem
  },
  computed: {
    ...mapGetters({ resources: 'getProjects' })
  }
}
</script>

<style></style>
